var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{staticClass:"e-btn-checkbox",attrs:{"variant":_vm.internalValue ? _vm.activeVariant : _vm.variant,"size":_vm.size},on:{"click":function($event){return _vm.setValue(!_vm.internalValue)}}},[_c('i',{staticClass:"mr-1",class:_vm.internalValue ? _vm.checkedIcon : _vm.uncheckedIcon}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }